import React from "react";
import "../styles.css";

let HorizontalRule = () => (
  <div>
    <hr className="border border-warning border-1 opacity-25 w-50 m-auto"></hr>
  </div>
);

export default HorizontalRule;
